import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { uniqueId } from "lodash";

import MaterialContainer from "../MaterialContainer";
import { TextInput } from "./Input";
import { InputPropTypes } from "../../propTypes";
import useMyDpdTheme from "../../Theme/useMyDpdTheme";

export const Control = ({
  label,
  placeholder,
  helperText,
  type,
  meta,
  input,
  required,
  disabled,
  readonly,
  classes,
  value,
  Component,
  borderless,
  showOptionalLabel,
  oneFromSeveral,
  forceLabel,
  ...inputProps
}) => {
  const theme = useMyDpdTheme();
  const labelWithRequiredSupport =
    label &&
    (oneFromSeveral
      ? `${label} **`
      : required
      ? `${label} *`
      : showOptionalLabel
      ? `${label} (Opt)`
      : label);
  const id = `${uniqueId("uuid-")}-${input?.name || new Date().getTime()}`;
  const formControl = (
    <Component
      {...inputProps}
      {...input}
      input={input}
      type={type}
      label={labelWithRequiredSupport}
      id={id}
      placeholder={placeholder}
      disabled={disabled}
      readonly={readonly}
      rounded={theme.material}
      value={input ? input.value : value}
      classes={classes}
      className={classNames("mydpd-form-control", classes.input)}
      error={meta?.error}
      meta={meta}
    />
  );
  if (theme.material) {
    return (
      <MaterialContainer
        {...inputProps}
        type={type}
        label={labelWithRequiredSupport}
        id={id}
        isLabelAnimated={theme.isLabelAnimated}
        placeholder={placeholder}
        helperText={helperText}
        input={input}
        meta={meta}
        classes={classes}
        disabled={disabled}
        readonly={readonly}
        required={required}
        borderless={borderless}
        value={input ? input.value : value}
        enableHelperTextTooltip={theme.enableHelperTextTooltip}
        forceLabel={forceLabel}
      >
        {formControl}
      </MaterialContainer>
    );
  }
  return formControl;
};

Control.defaultProps = {
  type: "text",
  required: false,
  borderless: false,
  showOptionalLabel: false,
  oneFromSeveral: false,
  Component: TextInput,
  classes: {
    container: {},
  },
};

Control.propTypes = {
  ...InputPropTypes,
  Component: PropTypes.elementType,
  classes: PropTypes.object,
  showOptionalLabel: PropTypes.bool,
  oneFromSeveral: PropTypes.bool,
  meta: PropTypes.object,
};
